var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.6 73.6H382.933V176H441.6V73.6Z",
    fill: "#F05540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 21.333H360.533V76.8H464V21.333Z",
    fill: "#F3705A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8 276.267V512H462.933V276.267C380.8 194.134 334.933 148.267 253.866 67.2C172.8 149.333 126.933 195.2 44.8 276.267Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 276.267C381.867 194.134 336 148.267 254.933 67.2C213.333 107.733 181.333 139.733 149.333 171.733C117.333 203.733 85.333 235.733 44.8 276.266V324.266C126.933 242.133 172.8 196.266 253.867 115.199C336 197.332 381.867 243.199 462.934 324.266V330.666V276.266H464V276.267Z",
    fill: "#F7B64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.533 512H90.667V388.267C90.667 353.067 119.467 325.334 153.6 325.334C188.8 325.334 216.533 354.134 216.533 388.267V512Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.134 325.333H253.867V469.333H418.134V325.333Z",
    fill: "#344A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.466 342.4H270.933V452.267H327.466V342.4Z",
    fill: "#8AD7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.066 342.4H344.533V452.267H401.066V342.4Z",
    fill: "#8AD7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.4 232.533L279.467 9.6C266.667 -3.2 244.267 -3.2 231.467 9.6L9.6 232.533C-3.2 245.333 -3.2 267.733 9.6 280.533C22.4 293.333 44.8 293.333 57.6 280.533L256 82.133L454.4 280.533C467.2 293.333 489.6 293.333 502.4 280.533C515.2 266.667 515.2 245.333 502.4 232.533Z",
    fill: "#F3705A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5afd4716ec39b6e64912ef5bdc431d46.svg";
export { ForwardRef as ReactComponent };